import { useState } from "react";
import { Logo } from "@/components/Brand";
import { ConsentChecks } from "@/components/LegalLinks";
import { api, errorText } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LogoutButton } from "@/components/LogoutButton";

export const ConsentScreen = () => {
  const { user, setUser } = useAuth();
  const [value, setValue] = useState({ terms: false, privacy: false });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const isNew = !user.consent_accepted_before;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/consent", { accept_terms: value.terms, accept_privacy: value.privacy });
      setUser(data);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen bg-papel px-6 py-10 sm:px-12 lg:px-24 lg:py-16" data-testid="consent-screen">
      <Logo size={52} testId="consent-logo" />
      <form onSubmit={submit} className="max-w-md mt-14 settle space-y-6">
        <h1 className="font-serif text-4xl leading-tight text-tinta">{isNew ? "Antes de empezar" : "Actualizamos nuestros términos"}</h1>
        <p className="text-sec">Para abrir tu diario necesitamos que aceptes los Términos y condiciones y el Aviso de privacidad vigentes. Puedes leerlos antes de marcar las casillas.</p>
        <ConsentChecks value={value} onChange={setValue} prefix="consent" />
        {error && <p className="calm-note" role="status" data-testid="consent-error">{error}</p>}
        <button type="submit" className="btn-primary w-full" disabled={busy || !value.terms || !value.privacy} data-testid="consent-submit-button">
          {busy ? "Un momento…" : "Aceptar y continuar"}
        </button>
        <LogoutButton className="btn-text -ml-2" testId="consent-logout-button" />
      </form>
    </div>
  );
};
